import {
  Show,
  SimpleShowLayout,
  TextField,
  RichTextField,
  NumberField,
  BooleanField,
  DateField,
  ArrayField,
  Datagrid,
} from 'react-admin';

export const PrivacySectionShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="subtitle" />
      <RichTextField source="description" />
      <NumberField source="sortOrder" />
      <BooleanField source="isActive" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
      
      <ArrayField source="items" label="Пункты политики">
        <Datagrid>
          <TextField source="title" label="Заголовок" />
          <RichTextField source="description" label="Описание" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);
